import { Context, useContext } from 'react';
import { FormContext } from '../contexts/form.context';
import { Form } from '../types/Form';

export function useForm<TEntity>(): Form<TEntity> {
    return useContext<Form<TEntity>>(FormContext as Context<Form<TEntity>>);
}
